/* Copyright Verge Technologies 2018
 * @file products.page.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React, { Component } from 'react';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import Products from '../../components/Products/products';
import { clearHash, loadIntoHash, retrieveFromHash } from '../../common/helper';

class ProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortBy: 'sugg',
      applications: [],
      brands: [],
      page: 0,
    };
  }

  componentDidMount() {
    const { application, brand } = this.props
    let brandsAr = [];
    let applicationsAr = [];
    if (application) {
      applicationsAr = retrieveFromHash();
    }
    if (brand) {
      brandsAr = retrieveFromHash();
    }
    window.scrollTo(0, 0);
    this.setState({ brands: brandsAr, applications: applicationsAr });
  }

  componentWillReceiveProps(props) {
    if (props.brand !== undefined && props.brand !== null) {
      this.setState({ applications: [] });
    } else if (props.application !== undefined && props.application !== null) {
      this.setState({ brands: [] });
    }
  }

  onSortChange = (e) => {
    this.setState({
      ...this.state,
      sortBy: e.target.value,
    });
  };

  updateApplicationFilter = async (applications) => {
    if (applications.length === 0) {
      clearHash();
    }
    this.setState({
      ...this.state,
      page: 0,
      applications,
    });
    loadIntoHash(applications);
  };

  updateBrandFilter = (brands) => {
    if (brands.length === 0) {
      clearHash()
    }
    this.setState({
      ...this.state,
      page: 0,
      brands,
    });
    loadIntoHash(brands);
  };

  updatePage = (page) => {
    this.setState({
      ...this.state,
      page,
    });
    //window.scrollTo(0, 0);
  };

  render() {
    return (
      <div>
        <Header
          products
          crumbs={this.props.crumbs}
          sortBy={this.state.sortBy}
          sortChange={() => this.onSortChange}
          filter={this.props.filter}
        />
        <Products
          filter={this.props.filter}
          applications={this.state.applications}
          brands={this.state.brands}
          id={this.props.brand || this.props.application}
          isBrand={this.props.brand}
          sortBy={this.state.sortBy}
          page={this.state.page}
          updateApplication={this.updateApplicationFilter}
          updateBrand={this.updateBrandFilter}
          updatePage={this.updatePage}
        />
        <Footer />
      </div>
    );
  }
}

export default ProductsPage;



// WEBPACK FOOTER //
// ./src/pages/products/products.page.js